import React, { useState } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Select, Input, Button } from 'antd';
import './style.css';
const SearchField = ({ handlePressEnter, placeholder, loading, onReset, handleOnChange, value, dropdown: { show = false, handleChange, optionsValue, optionValue }, enableSearchBtn = false }) => {
  const [searchValue, setSearchValue] = useState(null);
  const handleOnChangeValue = (e) => {
    if (e.target.value === '') {
      onReset();
    }
    setSearchValue(e.target.value);
    handleOnChange(e);
  };

  const renderSearchIcon = () => {
    const iconElement = (
      <SearchOutlined
        style={{ color: '#8C8C8C' }}
        onClick={() => {
          handlePressEnter(searchValue);
        }}
      />
    );
    return iconElement;
  };
  return (
    <div className='searchField'>
      <Input
        type='text'
        value={value}
        className='searchbar'
        onChange={handleOnChangeValue}
        placeholder={placeholder}
        allowClear={true}
        prefix={renderSearchIcon()}
        onPressEnter={() => {
          handlePressEnter(searchValue);
        }}
      />
      {show && (
        <Select
          labelInValue
          defaultValue={optionsValue && optionsValue?.length > 0 ? optionsValue[0] : null}
          value={optionValue}
          onChange={(e) => {
            handleChange(e);
          }}
          options={optionsValue}
        />
      )}
      {enableSearchBtn && (
        <Button className='ml-3 search-btn text-base' loading={loading} disabled={searchValue === null || searchValue.trim().length === 0 ? true : false} onClick={() => handlePressEnter(searchValue)}>
          Search
        </Button>
      )}
    </div>
  );
};
export default SearchField;
